<template>
  <div class='board-container'>
    <div class="detail-list">
      <RectLoading v-show="loading" class="loading"/>
      <div v-for="(item, index) in boardData" class="detail-item" :key="index">
        <div class="label">{{ item.label }}</div>
        <div class="count" :class="item.key">{{ interviewCount[item.key]|formatBigNumber }}</div>
        <div class="time">{{ $t(`${i18nPrefix}.label.asOfCurrent`, { currentTime }) }}</div>
      </div>
    </div>
    <div class="invite">
      <el-button icon="el-icon-circle-plus-outline" class="invite-btn" type="text" @click="handleInviteCandidateInterviewBtnClick"></el-button>
      <div class="description">{{ $t(`${i18nPrefix}.label.inviteCandidateToInterview`) }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import RectLoading from '@/components/loading/rectLoading.vue'

export default {
  components: {
    RectLoading
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      interviewCount: {
        upcoming: null,
        pending: null,
        completed: null
      },
      loading: false
    }
  },
  computed: {
    currentTime () {
      const locale = this.$i18n.locale
      if (locale === 'en') {
        moment.locale('en')
      } else {
        moment.locale('zh-cn')
      }
      return moment().format('H:mm A')
    },
    boardData () {
      const i18nPrefix = this.i18nPrefix
      const list = [
        {
          label: this.$t(`${i18nPrefix}.label.upcomingInterview`),
          key: 'upcoming'
        },
        {
          label: this.$t(`${i18nPrefix}.label.interviewResultsPending`),
          key: 'pending'
        },
        {
          label: this.$t(`${i18nPrefix}.label.completedInterviews`),
          key: 'completed'
        }
      ]
      return list
    },
    hasUniversalPermission () {
      return this.hasAnyPermission(['PERM_VIEW_UNIVERSAL_APPLICATION_LIST', 'PREMIUM_HR_DASHBOARD'])
    }
  },
  created () {
    this.loadInterviewBoardInfo()
  },
  methods: {
    ...mapActions('interview', ['getInterviewManagementDashboardInfo']),
    async loadInterviewBoardInfo () {
      this.loading = true
      try {
        const resp = await this.getInterviewManagementDashboardInfo()
        if (resp) {
          const interviewCount = this.interviewCount
          interviewCount.upcoming = resp.upcoming_count
          interviewCount.pending = resp.pending_count
          interviewCount.completed = resp.rated_count
        }
      } finally {
        this.loading = false
      }
    },
    handleInviteCandidateInterviewBtnClick () {
      let url = '/v-admin/job-list'
      if (this.hasUniversalPermission) {
        url = '/v-admin/application'
      }
      this.$router.push(url)
    }
  }
}
</script>

<style lang='scss' scoped>
.board-container {
  display: flex;

  .detail-list {
    position: relative;
    display: flex;
    padding: 20px 40px;
    flex: 1;
    background-color: #fff;
    box-shadow: 0px 3px 6px -4px rgba(0,0,0, 0.12);

    .detail-item {
      flex: 1;
      padding-right: 45px;
      position: relative;

      &::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 100%;
        background-color: #dcdfe6;
        position: absolute;
        right: 40px;
        top: 0;
      }

      &:last-child {
        &::after {
          display: none;
        }
      }

      .label {
        color: #606266;
        line-height: 20px;
      }

      .count {
        font-size: 28px;
        line-height: 40px;

        &.upcoming {
          color: #51abff;
        }

        &.pending {
          color: #f4a958;
        }

        &.completed {
          color: #51bf82
        }
      }

      .time {
        font-size: 12px;
        line-height: 18px;
        color: #909399;
      }
    }
  }

  .invite {
    margin-left: 14px;
    padding: 20px 40px;
    width: 335px;
    text-align: center;
    background-color: #fff;
    box-shadow: 0px 3px 6px -4px rgba(0,0,0, 0.12);

    .invite-btn {
      font-size: 32px;
      color: #c0c4cc;

      &:hover {
        color: #afb3bb;
      }
    }

    .description {
      font-size: 12px;
      color: #606266;
    }
  }

  .loading {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}
</style>
